// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3UZEa","content":"RecentSearches_content__4whQI"};